import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";

interface SearchFilterProps {
  className?: string;
  onSearch: (searchTerm: string) => void;
  defaultValue?: string;
}

const SearchFilter: React.FC<SearchFilterProps> = ({
  className,
  onSearch,
  defaultValue = "",
}) => {
  const [searchTerm, setSearchTerm] = useState(defaultValue);

  // Handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  // Initialize with default value if provided
  useEffect(() => {
    if (defaultValue) {
      setSearchTerm(defaultValue);
      onSearch(defaultValue);
    }
  }, [defaultValue, onSearch]);

  return (
    <div className={cn("relative w-full", className)}>
      <Search
        size={16}
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
      />
      <input
        type="text"
        value={searchTerm}
        onChange={handleChange}
        placeholder="Search by name or number"
        className="pl-10 pr-3 py-2 w-full rounded-md border border-gray-200 text-sm focus:outline-none focus:ring-1 focus:ring-brand-green focus:border-brand-green transition-all"
      />
    </div>
  );
};

export default SearchFilter;
